module.exports = __webpack_public_path__ + "img/logo_mtm.de724bd1.png";